import type { RotasDoModulo } from '@/app/rotas';

import { SettingsPage } from './SettingsPage';

/** Configuracoes da empresa. */
export const rotas: RotasDoModulo = {
  menu: { '/configuracoes': SettingsPage },
};
